export default __webpack_public_path__ + "static/media/Polygon.55c45951.svg";